import { native } from '@forest/native-services'
import { m } from '~/paraglide/messages'

export function BottomLinks() {
  return (
    <>
      <button
        class="text-[10px] font-normal text-[#A8A8A8] underline"
        onClick={() =>
          native.general.openURL(
            'https://forest-subscription.seekrtech.com/terms/',
          )
        }
      >
        {m.terms_of_service()}
      </button>
      <button
        class="text-[10px] font-normal text-[#A8A8A8] underline"
        onClick={() => native.general.openURL('https://forestapp.cc/privacy')}
      >
        {m.privacy_policy()}
      </button>
    </>
  )
}
